// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.earnings-container {
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
  width: 100%;
  margin: 0;
  padding: 1rem 1.5rem;
  box-sizing: border-box;
}

.earnings-week-sidebar {
  flex: 0 0 240px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  position: sticky;
  top: 1rem;
}

.earnings-week-sidebar h3 {
  margin: 0 0 0.75rem 0;
  font-size: 0.95rem;
  color: #444;
}

.earnings-week-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.earnings-week-item {
  width: 100%;
  text-align: left;
  background: #f7f7fa;
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 0.6rem 0.75rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 2px;
  transition: all 0.15s ease;
}

.earnings-week-item:hover {
  background: #eef0fb;
}

.earnings-week-item.active {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4c93 100%);
  border-color: transparent;
}

.earnings-week-item.active .earnings-week-range,
.earnings-week-item.active .earnings-week-quarter {
  color: #fff;
}

.earnings-week-range {
  font-weight: 600;
  font-size: 0.875rem;
  color: #222;
}

.earnings-week-quarter {
  font-size: 0.75rem;
  color: #777;
}

.earnings-week-badge {
  align-self: flex-start;
  margin-top: 4px;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: rgba(255, 255, 255, 0.25);
  color: inherit;
  padding: 2px 6px;
  border-radius: 4px;
}

.earnings-week-item:not(.active) .earnings-week-badge-this {
  background: #dff3e3;
  color: #1c7a3a;
}

.earnings-week-item:not(.active) .earnings-week-badge-next {
  background: #dbeafe;
  color: #1e40af;
}

.earnings-week-item:not(.active) .earnings-week-badge-past {
  background: #eee;
  color: #666;
}

.earnings-main {
  flex: 1 1;
  min-width: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1.25rem;
}

.earnings-header-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.earnings-header-row h2 {
  margin: 0;
  font-size: 1.15rem;
}

.earnings-quarter-badge {
  background: #eef0fb;
  color: #5a6fd8;
  font-weight: 600;
  font-size: 0.8rem;
  padding: 3px 10px;
  border-radius: 12px;
}

.earnings-search {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}

.earnings-filter {
  display: flex;
  align-items: center;
  gap: 6px;
}

.earnings-search label,
.earnings-filter label {
  font-size: 0.8rem;
  color: #555;
  font-weight: 600;
}

.earnings-search input {
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #ddd;
  background: #fff;
  font-size: 0.8rem;
  color: #333;
  width: 160px;
}

.earnings-filter select {
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #ddd;
  background: #fff;
  font-size: 0.8rem;
  color: #333;
  cursor: pointer;
}

.earnings-count-hint {
  flex-basis: 100%;
  font-size: 0.75rem;
  color: #999;
}

.earnings-search-results {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 10px 16px;
}

.earnings-search-results li {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #eee;
  border-left: 3px solid transparent;
}

.earnings-search-result-date {
  font-size: 0.7rem;
  font-weight: 700;
  color: #5a6fd8;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 4px;
}

.earnings-days {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.earnings-day-section {
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
}

.earnings-day-title {
  margin: 0;
  padding: 8px 14px;
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4c93 100%);
  color: #fff;
  font-size: 0.9rem;
}

.earnings-day-columns {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}

.earnings-timing-column {
  padding: 12px 16px;
  border-right: 1px solid #eee;
}

.earnings-timing-column:last-child {
  border-right: none;
}

.earnings-timing-column.earnings-timing-BMO {
  background: #fbfdfb;
}

.earnings-timing-column.earnings-timing-AMC {
  background: #fffbfb;
}

.earnings-timing-column.earnings-timing-UNKNOWN {
  background: #fafafa;
}

.earnings-timing-label {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
}

.earnings-timing-BMO .earnings-timing-label {
  color: #1c7a3a;
}

.earnings-timing-AMC .earnings-timing-label {
  color: #b02a2a;
}

.earnings-timing-UNKNOWN .earnings-timing-label {
  color: #888;
}

.earnings-company-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 8px 16px;
}

.earnings-company-list li {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  padding: 4px 6px;
  border-radius: 6px;
  border-left: 3px solid transparent;
}

.earnings-company-name {
  font-weight: 600;
  color: #222;
  font-size: 0.85rem;
}

.earnings-company-ticker {
  color: #888;
  font-size: 0.7rem;
  letter-spacing: 0.03em;
}

.earnings-company-mcap {
  color: #aaa;
  font-weight: 600;
}

.earnings-held-open .earnings-company-mcap {
  color: #b98527;
}

/* Open position: stand out from the rest of the list without clashing with the green
   (before-open) / red (after-close) column accents already in use. */
.earnings-company-list li.earnings-held-open {
  background: rgba(245, 158, 11, 0.14);
  border-left-color: #d97706;
  box-shadow: 0 0 0 1px rgba(217, 119, 6, 0.25);
}

.earnings-held-open .earnings-company-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: #7c4a03;
}

.earnings-held-open .earnings-company-ticker {
  color: #a3690f;
  font-weight: 600;
}

/* Traded before, but no open position now: a clearly cooler/muted tier — visible but
   subordinate to a live open position. */
.earnings-company-list li.earnings-held-past {
  background: rgba(100, 116, 139, 0.10);
  border-left-color: #64748b;
}

.earnings-held-past .earnings-company-name {
  font-weight: 700;
  color: #334155;
}

.earnings-held-past .earnings-company-ticker {
  color: #64748b;
  font-weight: 600;
}

/* Holder info block: one aligned row per person, each with their position type(s) and
   broker pill(s), so multi-holder / multi-broker cases stay scannable instead of turning
   into one long wrapped string. */
.earnings-held-info {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.earnings-held-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 0.62rem;
}

.earnings-held-name {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
}

.earnings-held-open .earnings-held-name {
  color: #7c4a03;
}

.earnings-held-past .earnings-held-name {
  color: #334155;
}

/* Right-aligned group: holds one or more type+broker pairs on the same line, e.g. an
   Option (IBKR) pill next to a Stock (Tasty) pill when a position exists on both. */
.earnings-held-details {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 auto;
}

.earnings-held-detail {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #555;
  font-weight: 600;
  white-space: nowrap;
}

.earnings-broker-pill {
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 1px 5px;
  border-radius: 3px;
  color: #fff;
}

.earnings-broker-ibkr {
  background: #2563eb;
}

.earnings-broker-tastytrade {
  background: #7c3aed;
}

.earnings-empty-slot {
  margin: 0;
  color: #aaa;
  font-size: 0.8rem;
  font-style: italic;
}

@media (max-width: 900px) {
  .earnings-day-columns {
    grid-template-columns: 1fr;
  }
  .earnings-timing-column {
    border-right: none;
    border-bottom: 1px solid #eee;
  }
  .earnings-timing-column:last-child {
    border-bottom: none;
  }
}

.earnings-empty-hint {
  color: #888;
  font-style: italic;
}

.earnings-error {
  color: #b02a2a;
}

@media (max-width: 900px) {
  .earnings-container {
    flex-direction: column;
  }
  .earnings-week-sidebar {
    flex: 1 1 auto;
    position: static;
    width: 100%;
    box-sizing: border-box;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Earnings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,6DAA6D;EAC7D,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,4DAA4D;EAC5D,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;qEACqE;AACrE;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;yCACyC;AACzC;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;kCAEkC;AAClC;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;oFACoF;AACpF;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,sBAAsB;EACxB;AACF","sourcesContent":[".earnings-container {\n  display: flex;\n  gap: 1.5rem;\n  align-items: flex-start;\n  width: 100%;\n  margin: 0;\n  padding: 1rem 1.5rem;\n  box-sizing: border-box;\n}\n\n.earnings-week-sidebar {\n  flex: 0 0 240px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 1rem;\n  position: sticky;\n  top: 1rem;\n}\n\n.earnings-week-sidebar h3 {\n  margin: 0 0 0.75rem 0;\n  font-size: 0.95rem;\n  color: #444;\n}\n\n.earnings-week-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.earnings-week-item {\n  width: 100%;\n  text-align: left;\n  background: #f7f7fa;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  padding: 0.6rem 0.75rem;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  transition: all 0.15s ease;\n}\n\n.earnings-week-item:hover {\n  background: #eef0fb;\n}\n\n.earnings-week-item.active {\n  background: linear-gradient(135deg, #5a6fd8 0%, #6a4c93 100%);\n  border-color: transparent;\n}\n\n.earnings-week-item.active .earnings-week-range,\n.earnings-week-item.active .earnings-week-quarter {\n  color: #fff;\n}\n\n.earnings-week-range {\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: #222;\n}\n\n.earnings-week-quarter {\n  font-size: 0.75rem;\n  color: #777;\n}\n\n.earnings-week-badge {\n  align-self: flex-start;\n  margin-top: 4px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  background: rgba(255, 255, 255, 0.25);\n  color: inherit;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.earnings-week-item:not(.active) .earnings-week-badge-this {\n  background: #dff3e3;\n  color: #1c7a3a;\n}\n\n.earnings-week-item:not(.active) .earnings-week-badge-next {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.earnings-week-item:not(.active) .earnings-week-badge-past {\n  background: #eee;\n  color: #666;\n}\n\n.earnings-main {\n  flex: 1;\n  min-width: 0;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  padding: 1.25rem;\n}\n\n.earnings-header-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.earnings-header-row h2 {\n  margin: 0;\n  font-size: 1.15rem;\n}\n\n.earnings-quarter-badge {\n  background: #eef0fb;\n  color: #5a6fd8;\n  font-weight: 600;\n  font-size: 0.8rem;\n  padding: 3px 10px;\n  border-radius: 12px;\n}\n\n.earnings-search {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: auto;\n}\n\n.earnings-filter {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.earnings-search label,\n.earnings-filter label {\n  font-size: 0.8rem;\n  color: #555;\n  font-weight: 600;\n}\n\n.earnings-search input {\n  padding: 5px 10px;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n  background: #fff;\n  font-size: 0.8rem;\n  color: #333;\n  width: 160px;\n}\n\n.earnings-filter select {\n  padding: 5px 10px;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n  background: #fff;\n  font-size: 0.8rem;\n  color: #333;\n  cursor: pointer;\n}\n\n.earnings-count-hint {\n  flex-basis: 100%;\n  font-size: 0.75rem;\n  color: #999;\n}\n\n.earnings-search-results {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 10px 16px;\n}\n\n.earnings-search-results li {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n  padding: 10px 12px;\n  border-radius: 6px;\n  border: 1px solid #eee;\n  border-left: 3px solid transparent;\n}\n\n.earnings-search-result-date {\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: #5a6fd8;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  margin-bottom: 4px;\n}\n\n.earnings-days {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.earnings-day-section {\n  border: 1px solid #eee;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.earnings-day-title {\n  margin: 0;\n  padding: 8px 14px;\n  background: linear-gradient(135deg, #5a6fd8 0%, #6a4c93 100%);\n  color: #fff;\n  font-size: 0.9rem;\n}\n\n.earnings-day-columns {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n}\n\n.earnings-timing-column {\n  padding: 12px 16px;\n  border-right: 1px solid #eee;\n}\n\n.earnings-timing-column:last-child {\n  border-right: none;\n}\n\n.earnings-timing-column.earnings-timing-BMO {\n  background: #fbfdfb;\n}\n\n.earnings-timing-column.earnings-timing-AMC {\n  background: #fffbfb;\n}\n\n.earnings-timing-column.earnings-timing-UNKNOWN {\n  background: #fafafa;\n}\n\n.earnings-timing-label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 8px;\n}\n\n.earnings-timing-BMO .earnings-timing-label {\n  color: #1c7a3a;\n}\n\n.earnings-timing-AMC .earnings-timing-label {\n  color: #b02a2a;\n}\n\n.earnings-timing-UNKNOWN .earnings-timing-label {\n  color: #888;\n}\n\n.earnings-company-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 8px 16px;\n}\n\n.earnings-company-list li {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n  padding: 4px 6px;\n  border-radius: 6px;\n  border-left: 3px solid transparent;\n}\n\n.earnings-company-name {\n  font-weight: 600;\n  color: #222;\n  font-size: 0.85rem;\n}\n\n.earnings-company-ticker {\n  color: #888;\n  font-size: 0.7rem;\n  letter-spacing: 0.03em;\n}\n\n.earnings-company-mcap {\n  color: #aaa;\n  font-weight: 600;\n}\n\n.earnings-held-open .earnings-company-mcap {\n  color: #b98527;\n}\n\n/* Open position: stand out from the rest of the list without clashing with the green\n   (before-open) / red (after-close) column accents already in use. */\n.earnings-company-list li.earnings-held-open {\n  background: rgba(245, 158, 11, 0.14);\n  border-left-color: #d97706;\n  box-shadow: 0 0 0 1px rgba(217, 119, 6, 0.25);\n}\n\n.earnings-held-open .earnings-company-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #7c4a03;\n}\n\n.earnings-held-open .earnings-company-ticker {\n  color: #a3690f;\n  font-weight: 600;\n}\n\n/* Traded before, but no open position now: a clearly cooler/muted tier — visible but\n   subordinate to a live open position. */\n.earnings-company-list li.earnings-held-past {\n  background: rgba(100, 116, 139, 0.10);\n  border-left-color: #64748b;\n}\n\n.earnings-held-past .earnings-company-name {\n  font-weight: 700;\n  color: #334155;\n}\n\n.earnings-held-past .earnings-company-ticker {\n  color: #64748b;\n  font-weight: 600;\n}\n\n/* Holder info block: one aligned row per person, each with their position type(s) and\n   broker pill(s), so multi-holder / multi-broker cases stay scannable instead of turning\n   into one long wrapped string. */\n.earnings-held-info {\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.earnings-held-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 0.62rem;\n}\n\n.earnings-held-name {\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  white-space: nowrap;\n}\n\n.earnings-held-open .earnings-held-name {\n  color: #7c4a03;\n}\n\n.earnings-held-past .earnings-held-name {\n  color: #334155;\n}\n\n/* Right-aligned group: holds one or more type+broker pairs on the same line, e.g. an\n   Option (IBKR) pill next to a Stock (Tasty) pill when a position exists on both. */\n.earnings-held-details {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.earnings-held-detail {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  color: #555;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.earnings-broker-pill {\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  padding: 1px 5px;\n  border-radius: 3px;\n  color: #fff;\n}\n\n.earnings-broker-ibkr {\n  background: #2563eb;\n}\n\n.earnings-broker-tastytrade {\n  background: #7c3aed;\n}\n\n.earnings-empty-slot {\n  margin: 0;\n  color: #aaa;\n  font-size: 0.8rem;\n  font-style: italic;\n}\n\n@media (max-width: 900px) {\n  .earnings-day-columns {\n    grid-template-columns: 1fr;\n  }\n  .earnings-timing-column {\n    border-right: none;\n    border-bottom: 1px solid #eee;\n  }\n  .earnings-timing-column:last-child {\n    border-bottom: none;\n  }\n}\n\n.earnings-empty-hint {\n  color: #888;\n  font-style: italic;\n}\n\n.earnings-error {\n  color: #b02a2a;\n}\n\n@media (max-width: 900px) {\n  .earnings-container {\n    flex-direction: column;\n  }\n  .earnings-week-sidebar {\n    flex: 1 1 auto;\n    position: static;\n    width: 100%;\n    box-sizing: border-box;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
